<template>
    <div>
        <!-- <div v-for="(list, index) in statusType" :key="index"> -->
        <span class="status-view" :class="statusClass">
            <i :class="statusIcon"></i> <span>{{ statusLabel }}</span>
        </span>
        <!-- </div> -->
    </div>
</template>

<script>
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        statusType: {
            type: String,
            default: null,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        statusIcon() {
            if (this.statusType == 'active') {
                return 'icon-check'
            }
            if (this.statusType == 'inactive') {
                return 'icon-wrong'
            }
            if (this.statusType == 'locked') {
                return 'icon-change-password'
            }
            if (
                this.statusType == 'pending' ||
                this.statusType == 'potential'
            ) {
                return 'icon-loading'
            }
            if (this.statusType == 'high') {
                return 'icon-high-risk'
            }
            if (this.statusType == 'low') {
                return 'icon-low-risk'
            }
            if (this.statusType == 'medium') {
                return 'icon-medium-risk'
            }
            if (this.statusType == 'sanction') {
                return 'icon-sanction'
            }
            if (this.statusType == 'approved') {
                return 'icon-check'
            }
            if (this.statusType == 'submitted') {
                return 'icon-check'
            }
            if (this.statusType == 'hit') {
                return 'icon-wrong'
            }
            if (this.statusType == '') {
                return 'icon-check'
            }
            if (this.statusType == 'return-alert') {
                return 'icon-wrong'
            }
            return 'icon-wrong'
        },
        statusClass() {
            if (this.statusType == 'active') {
                return 'approved'
            }
            if (this.statusType == 'inactive') {
                return 'rejected'
            }
            if (this.statusType == 'locked') {
                return 'locked'
            }
            if (
                this.statusType == 'pending' ||
                this.statusType == 'potential'
            ) {
                return 'pending'
            }

            if (this.statusType == 'high') {
                return 'high-risk'
            }
            if (this.statusType == 'low') {
                return 'low-risk'
            }
            if (this.statusType == 'medium') {
                return 'medium-risk'
            }
            if (this.statusType == 'sanction') {
                return 'sanctioned-risk'
            }
            if (this.statusType == 'approved') {
                return 'approved'
            }
            if (this.statusType == 'submitted') {
                return 'submitted'
            }
            if (this.statusType == 'hit') {
                return 'high-risk'
            }
            if (this.statusType == '') {
                return 'low-risk'
            }
            if (this.statusType == 'return-alert') {
                return 'rejected'
            }
            if (this.statusType == 'in-active') {
                return 'rejected'
            }
            return 'rejected'
        },
        statusLabel() {
            if (this.statusType == 'active') {
                return 'Active'
            }
            if (this.statusType == 'inactive') {
                return 'Rejected'
            }
            if (this.statusType == 'locked') {
                return 'Locked'
            }
            if (this.statusType == 'pending') {
                return 'Pending'
            }
            if (this.statusType == 'potential') {
                return 'Potential'
            }
            if (this.statusType == 'high') {
                return 'High Risk'
            }
            if (this.statusType == 'low') {
                return 'Low Risk'
            }
            if (this.statusType == 'medium') {
                return 'Medium Risk'
            }
            if (this.statusType == 'sanction') {
                return 'Sanctioned'
            }
            if (this.statusType == 'approved') {
                return 'Approved'
            }
            if (this.statusType == 'rejected') {
                return 'Rejected'
            }
            if (this.statusType == 'hit') {
                return 'Genuine'
            }
            if (this.statusType == 'submitted') {
                return 'Submitted'
            }
            if (this.statusType == '') {
                return 'Not Genuine'
            }
            if (this.statusType == 'return-alert') {
                return 'Returned'
            }
            if (this.statusType == 'in-active') {
                return 'In-Active'
            }
            return 'Archived'
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {}, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {}, // End of Component > mounted
} // End of export default
</script>
